import React from 'react';
// import Header from './Header';
// import Footer from './Footer';

const YearlyActivities = () => {
  return (
    <>
      {/* <Header /> */}
      {/*==============================
    Breadcumb
============================== */}

      <div className="breadcumb-wrapper" style={{ backgroundImage: `url('assets/img/bg/breadcumb-bg.jpg')`, backgroundPosition: 'center', backgroundSize: 'cover' }}>

        {/* <div className="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg"> */}
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Yearly Activities</h1>
          </div>
        </div>
      </div>

      <section className="bg-theme overflow-hidden space overflow-hidden" data-bg-src="assets/img/bg/event_bg_shape.html">
        <div className="container">
          <div className="row gy-4 gx-40">
            <div className="col-xl-6">
              <div className="event-card wow fadeInUp" data-wow-delay=".3s">
                <div className="box-img global-img">
                  <img src="assets/img/activities/narasimha-sahasranama.jpg" alt="event" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">
                    SHANKARA JAYANTI
                  </h3>
                </div>
              </div>
              <div className="event-card wow fadeInUp" data-wow-delay=".3s">
                <div className="box-img global-img">
                  <img src="assets/img/activities/vardhanti.jpg" alt="event" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">
                    VARDHANTHI MAHOTSAVA
                  </h3>
                </div>
              </div>

              <div className="event-card wow fadeInUp" data-wow-delay=".4s">
                <div className="box-img global-img">
                  <img src="assets/img/activities/narasimha-kutumba.jpg" alt="event" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">
                    NAVARATHIRI
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="event-card wow fadeInUp" data-wow-delay=".4s">
                <div className="box-img global-img">
                  <img src="assets/img/activities/narasimha-anugraha-sanchara.jpg" alt="event" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">
                    NARASIMHA JAYANTI
                  </h3>
                </div>
              </div>

              <div className="event-card wow fadeInUp" data-wow-delay=".4s">
                <div className="box-img global-img">
                  <img src="assets/img/activities/chaturmasa.jpg" alt="event" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">
                    CHATHURMASA
                  </h3>
                </div>
              </div>
              <div className="event-card wow fadeInUp" data-wow-delay=".4s">
                <div className="box-img global-img">
                  <img src="assets/img/activities/bhramho.jpg" alt="event" />
                </div>
                <div className="box-content">
                  <h3 className="box-title">
                    BRAHMOTSAVA
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
};

export default YearlyActivities;
